module.exports = __webpack_public_path__ + "assets/img/vue2_entry.503467cc.jpg";